<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowUnitRefundRate',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_ha_refunded', throughMonth),
          this.getYtdByField(yearObj, 'number_ha_sold', throughMonth),
          0,
        );
      },
    },
  };
</script>
